import { storageService } from '@/services'
import { isNullOrUndefined, isObject } from '~/util/validators/baseComponentsValidators'

export default ({ app: { store, router, $newModal, $ab } }) => {
  router.beforeEach((to, from, next) => {

    // Skip for initial page load
    if (!from.name) return next()

    // Skip, if navigation not to cashbox
    if (!to.fullPath.includes('cashbox')) return next()

    // Skip for verified
    const isVerified = store.getters['user/isUserVerified']
    if (isVerified) return next()

    // If old ab group and it's first dep
    if ($ab().old && store.getters['user/user'].payin_count === 0) return next()

    // Allow internal cashbox navigation
    const fromCashbox = from.path.includes('cashbox')
    if (fromCashbox) return next()

    // Skip, if navigating from such modal
    const fromSameModal = from?.query?.modal === 'verify-before-pay'
    if (fromSameModal) return next()

    // Skip, if navigating from registration bonuses
    const fromRegistrationBonuses = from.query.bigModal === 'registrationBonuses'
    if (fromRegistrationBonuses) return next()

    // show modal
    next(false)
    store.dispatch('globalModal/open_globalModalVerifyBeforePay')
  })

  router.afterEach((to, _from) => {
    if (to.query.refcode && storageService.getToken()) {
      storageService.setAffise(to.query.refcode)
    }
    if (~to.fullPath.indexOf('utm')) {
      const fullPath = to.fullPath
      const expDate = new Date()
      const domain = window.location.hostname
      const utm = fullPath.slice(fullPath.indexOf('utm'))

      expDate.setHours(expDate.getHours() + 24)
      storageService.setItem('utm', utm, expDate, '/', domain)
    }

    if (to.query.hasOwnProperty('refcode')) {
      const expDate = new Date()
      expDate.setDate(expDate.getDate() + 1)
      const refCode = to.query.refcode
      const subId = to.query.hasOwnProperty('subid') ? to.query.subid : ''
      const referer = document.referrer
      let domain = window.location.hostname
      const chunks = domain.split('.')
      if (chunks.length > 1) domain = chunks.slice(-2).join('.')

      storageService.setItem('adw_refcode', refCode, expDate, '/', domain)
      storageService.setItem('adw_subid', subId, expDate, '/', domain)
      storageService.setItem('adw_referer', referer, expDate, '/', domain)
    }

    if (to.query.hasOwnProperty('stag')) {
      const expDate = new Date()
      expDate.setDate(expDate.getDate() + 1)
      const stag = to.query.stag
      let domain = window.location.hostname
      const chunks = domain.split('.')
      if (chunks.length > 1) {
        domain = chunks.slice(-2)
          .join('.')
      }
      storageService.setItem('stag', stag, expDate, '/', domain)
    }

    if (to.query.hasOwnProperty('promoCode') && !to.fullPath.includes('PPCode')) {
      const routerQuery = { ...to.query }
      const expDate = new Date()
      const domain = window.location.hostname
      const promoCode = routerQuery.promoCode

      delete routerQuery.promoCode

      if (storageService.getToken()) {
        router.replace({ query: routerQuery })
      }
      else {
        $newModal.openAuthOrRegister({ noOldQuery: true, id: 'router-tracker' })
      }
      expDate.setFullYear(expDate.getFullYear() + 1)
      storageService.setItem('promoCode', promoCode, expDate, '/', domain)
    }
    if (to.fullPath.includes('PPCode')) {
      // promoCode example: PPCode5_ABCDE
      const promoUrl = to.fullPath
      const match = promoUrl.match(/PPCode_([\w]+)/)

      if (match) {
        const promoCode = match[1]

        const routerQuery = { ...to.query }
        Object.keys(routerQuery).forEach((key) => {
          if (routerQuery[key] && routerQuery[key].includes('PPCode')) {
            delete routerQuery[key]
          }
        })

        router.push({ query: routerQuery })

        const expDate = new Date()
        const domain = window.location.hostname
        expDate.setFullYear(expDate.getFullYear() + 1)
        storageService.setItem('promoCode', promoCode, expDate, '/', domain)
      }
    }
    if (to.fullPath.includes('token')) {
      // emailCode example: token=e77ce1
      const emailUrl = to.fullPath
      const urlParams = new URLSearchParams(emailUrl.split('?')[1])
      const emailCode = urlParams.get('token')

      const routerQuery = { ...to.query }
      Object.keys(routerQuery).forEach((key) => {
        if (key === 'token') {
          delete routerQuery[key]
        }
      })
      router.push({ query: routerQuery })

      const FIVE_MINUTES = 5 * 60 * 1000
      const expDate = new Date(Date.now() + FIVE_MINUTES)
      const domain = window.location.hostname
      storageService.setItem('emailCode', emailCode, expDate, '/', domain)
    }
    if (storageService.getItem('token') && storageService.getItem('utm')) {
      store.dispatch('user/SEND_UTM', storageService.getItem('utm'))
      storageService.removeItem('utm')
    }
  })
}
